var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16340",
    fill: "none",
    stroke: "#656565",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12365",
    d: "M10.54 15.113a8.314 8.314 0 001.127 16.553H30a6.667 6.667 0 000-13.333 10 10 0 00-19.46-3.22z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12366",
    d: "M25.553 21.666h-6.67"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12367",
    d: "M25.55 23.733v-2.067"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12368",
    d: "M22.216 23.733v-2.067"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12369",
    d: "M18.238 20.096a2.222 2.222 0 11-3.142 0 2.222 2.222 0 013.142 0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12370",
    d: "M0 0h40v40H0z",
    fill: "none"
  })));
}
export default SvgCloud;


//////////////////
// WEBPACK FOOTER
// ./src/icons/cloud.svg
// module id = 198
// module chunks = 13